import type { Route } from 'next';
import Link from 'next/link';

import { NextImageWrapper, Carousel  } from '@/modules/shared/presentation/components';
import type { CarouselRootProps } from '@/modules/shared/presentation/components';
import type { Image } from '@/modules/shared/types';

type SlidingHeroBannerProps = {
	carouselSlides: {
		href:  string
		image: Image
	}[]
} & CarouselRootProps;

export const HeroCarousel = ({ carouselSlides, ...props }: SlidingHeroBannerProps) => {
	return (
		<Carousel.Root {...props}>
			<Carousel.Swiper>
				{carouselSlides.map((slide, index) => (
					<Carousel.Slide key={slide.href + index}>
						<Link href={slide.href as Route}>
							<NextImageWrapper aspectRatio="wide" image={slide.image} sizes="50vw" />
						</Link>
					</Carousel.Slide>
				))}
			</Carousel.Swiper>
		</Carousel.Root>
	);
};
